export const productsList = [
    {
      title: "Our Client Projects",
      description: "Explore beautifully designed and fully responsive websites we’ve built for our clients across different industries.",
      link: "/projects",
      image: "/products/product1.png",
    },
    {
      title: "Our Client Logos",
      description: "Browse through a collection of creative, professional logos crafted to capture each brand’s identity and vision.",
      link: "/logos",
      image: "/products/product2.jpeg",
    },
    {
      title: "Our Client Posters",
      description: "Check out visually striking posters designed to effectively promote our clients’ events, services, and campaigns.",
      link: "/posters",
      image: "/products/product3.jpeg",
    },
  ];
  